import React from "react";
import {
  FormControlLabel,
  Link as MUILink,
  Stack,
  Typography,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { Link as RouterLink } from "react-router-dom";

const JoinTermsCheckbox = ({
  checked,
  onChange,
}) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          id="remember"
          name="remember"
          checked={checked}
          onChange={onChange}
        />
      }
      label={
        <Stack direction="row">
          <Typography variant="subtitle2">
            I agree to all&nbsp;
            <>
              <RouterLink
                to="/terms"
                target="_blank"
                rel="noopener noreferrer"
              >
                <MUILink
                  component="span"
                  variant="subtitle2"
                >
                  terms and conditions
                </MUILink>
              </RouterLink>
            </>
            &nbsp;*
          </Typography>
        </Stack>
      }
    />
  );
};

export default JoinTermsCheckbox;